import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

import { UNPROCESSABLE_FILE_WARNING } from 'src/shared/utils/fileTypeUtils';

import { cn } from 'src/shared/components/ui';
import { Typography } from 'src/shared/components/ui';

interface UnprocessableFileWarningProps {
  /** Use 'inline' for compact placement under a list row, 'block' for stand-alone notice. */
  variant?: 'inline' | 'block';
  className?: string;
}

/**
 * Warning shown for files that are accepted for upload but cannot be processed
 * by the LLM during RFQ creation (e.g. .ai files). The file is still attached
 * to the RFQ; it just won't contribute to RFQ generation.
 */
export function UnprocessableFileWarning({
  variant = 'inline',
  className
}: UnprocessableFileWarningProps) {
  if (variant === 'block') {
    return (
      <div
        className={cn(
          'flex items-start gap-2 px-3 py-2 rounded-lg bg-cavela-yellow-light-3',
          className
        )}
      >
        <ExclamationTriangleIcon className="size-4 text-cavela-yellow-dark-2 mt-0.5 flex-shrink-0" />
        <Typography variant="body-2" className="text-cavela-yellow-dark-2">
          {UNPROCESSABLE_FILE_WARNING}
        </Typography>
      </div>
    );
  }

  return (
    <div className={cn('flex items-start gap-1.5 mt-1', className)}>
      <ExclamationTriangleIcon className="size-3.5 text-cavela-yellow-dark-2 mt-0.5 flex-shrink-0" />
      <Typography variant="body-2" className="text-cavela-yellow-dark-2">
        {UNPROCESSABLE_FILE_WARNING}
      </Typography>
    </div>
  );
}
